import * as React from 'react';

import { useTranslation } from 'react-i18next';

import * as Styled from './loader.styled';

interface LoaderProps {
	text?: string;
}

const Loader: React.FC<LoaderProps> = ({ 
	text
}) => {
	const { t } = useTranslation('main');
	const displayText = text || t('loading');

	return (
		<Styled.Container>
			<Styled.Text>
				{displayText}
			</Styled.Text>
			<Styled.ProgressWrapper>
				<Styled.ProgressBar />
			</Styled.ProgressWrapper>
		</Styled.Container>
	);
};

export default Loader;